import * as i0 from '@angular/core';
import { Injectable, InjectionToken, Inject, Optional, Injector, NgModule } from '@angular/core';
import { BehaviorSubject, of, NEVER } from 'rxjs';
import { filter, switchMap, map, delay } from 'rxjs/operators';
import * as i2 from '@angular/router';
import { Router } from '@angular/router';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpHandler, HttpClient, HttpClientModule } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common/http';
class TokenPayload {
    /**
     * Shows if the token is valid, e.g. it has not expired
     */
    isValid() {
        return this.expires ? Date.now() < +this.expires : true;
    }
    /**
     * Unix timestamp in microseconds
     */
    get expires() {
        // by default check the JWT exp property @see https://tools.ietf.org/html/rfc7519#section-4.1.4
        return this.exp && this.exp * 1000;
    }
}

class TokenDecoder {
    decode(token) {
        return new TokenPayload();
    }
}
TokenDecoder.ɵfac = function TokenDecoder_Factory(t) { return new (t || TokenDecoder)(); };
/** @nocollapse */ TokenDecoder.ɵprov = i0.ɵɵdefineInjectable({ factory: function TokenDecoder_Factory() { return new TokenDecoder(); }, token: TokenDecoder, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TokenDecoder, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

function localStorageFactory() {
    return typeof localStorage !== 'undefined' ? localStorage : undefined;
}
/**
 * TokenStorage to use basically it is a subset of Storage (localStorage or sessionStorage)
 */
class TokenStorage {
}
TokenStorage.ɵfac = function TokenStorage_Factory(t) { return new (t || TokenStorage)(); };
/** @nocollapse */ TokenStorage.ɵprov = i0.ɵɵdefineInjectable({ factory: localStorageFactory, token: TokenStorage, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TokenStorage, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
                useFactory: localStorageFactory
            }]
    }], null, null); })();

const AUTH_TOKEN_NAME = new InjectionToken('AUTH_TOKEN_NAME', {
    providedIn: 'root',
    factory: () => 'id_token'
});

const AUTH_TOKEN_AUTO_REMOVE = new InjectionToken('AUTH_TOKEN_AUTO_REMOVE', {
    providedIn: 'root',
    factory: () => true
});

class AuthTokenService {
    constructor(storage, decoder, autoRemove, authTokenName) {
        this.storage = storage;
        this.decoder = decoder;
        this.autoRemove = autoRemove;
        this.authTokenName = 'id_token';
        this.tokenPayload = undefined;
        this.authTokenName = authTokenName || this.authTokenName;
        this.value$ = new BehaviorSubject(this.getToken());
        this.value$.subscribe((token) => this.setToken(token));
        if (this.autoRemove) {
            this.activateTokenAutoRemove();
        }
    }
    /**
     * The current raw value of the token
     */
    get value() {
        return this.value$.value;
    }
    get payload() {
        return this.tokenPayload;
    }
    ngOnDestroy() {
        this.value$.unsubscribe();
        this.deactivateTokenAutoRemove();
    }
    isValid() {
        return !!(this.payload && this.payload.isValid());
    }
    activateTokenAutoRemove() {
        this.deactivateTokenAutoRemove();
        this.autoRemoveTokenSubscription = this.removeTokenWhenNotValidOrExpires();
        this.autoRemove = true;
    }
    deactivateTokenAutoRemove() {
        if (this.autoRemoveTokenSubscription) {
            this.autoRemoveTokenSubscription.unsubscribe();
            this.autoRemoveTokenSubscription = undefined;
        }
        this.autoRemove = false;
    }
    setToken(token) {
        if (token) {
            this.storage.setItem(this.authTokenName, token);
            this.tokenPayload = Object.freeze(this.decoder.decode(token));
        }
        else {
            this.storage.removeItem(this.authTokenName);
            this.tokenPayload = undefined;
        }
    }
    getToken() {
        return this.storage.getItem(this.authTokenName) || undefined;
    }
    removeTokenWhenNotValidOrExpires() {
        return this.value$
            .pipe(filter((token) => !!token), switchMap(() => {
            const isValid = this.isValid();
            if (!isValid) {
                return of({
                    reason: '_token_not_valid_'
                });
            }
            return of(this.payload).pipe(switchMap((payload) => this.whenTokenExpires(payload)), map((expires) => {
                return {
                    reason: '_token_expired_'
                };
            }));
        }))
            .subscribe(() => this.value$.next(undefined));
    }
    whenTokenExpires(payload) {
        return of(payload).pipe(switchMap(({ expires }) => {
            if (expires) {
                // the token has an expiration date, so check and use it
                const expiresAfter = expires - Date.now();
                const delayTo = expiresAfter > 0 ? new Date(expires) : 0;
                return of(expires).pipe(delay(delayTo));
            }
            else {
                // the token never expires
                return NEVER;
            }
        }));
    }
}
AuthTokenService.ɵfac = function AuthTokenService_Factory(t) { return new (t || AuthTokenService)(ɵngcc0.ɵɵinject(TokenStorage), ɵngcc0.ɵɵinject(TokenDecoder), ɵngcc0.ɵɵinject(AUTH_TOKEN_AUTO_REMOVE), ɵngcc0.ɵɵinject(AUTH_TOKEN_NAME, 8)); };
/** @nocollapse */ AuthTokenService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AuthTokenService_Factory() { return new AuthTokenService(i0.ɵɵinject(TokenStorage), i0.ɵɵinject(TokenDecoder), i0.ɵɵinject(AUTH_TOKEN_AUTO_REMOVE), i0.ɵɵinject(AUTH_TOKEN_NAME, 8)); }, token: AuthTokenService, providedIn: "root" });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
AuthTokenService.ctorParameters = () => [
    { type: TokenStorage },
    { type: TokenDecoder },
    { type: Boolean, decorators: [{ type: Inject, args: [AUTH_TOKEN_AUTO_REMOVE,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [AUTH_TOKEN_NAME,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthTokenService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: TokenStorage }, { type: TokenDecoder }, { type: Boolean, decorators: [{
                type: Inject,
                args: [AUTH_TOKEN_AUTO_REMOVE]
            }] }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AUTH_TOKEN_NAME]
            }] }]; }, null); })();

/*
 * Public API Surface of ngx-api-utils/auth-token
 */

const API_AUTH_GUARD_PUBLIC_ONLY_ROUTES = new InjectionToken('API_AUTH_GUARD_PUBLIC_ONLY_ROUTES');

const API_AUTH_GUARD_URL_FOR_AUTHENTICATED = new InjectionToken('API_AUTH_GUARD_URL_FOR_AUTHENTICATED', {
    providedIn: 'root',
    factory: () => '/'
});

const API_AUTH_GUARD_URL_FOR_AUTHENTICATION = new InjectionToken('API_AUTH_GUARD_URL_FOR_AUTHENTICATION', {
    providedIn: 'root',
    factory: () => '/login'
});

class ApiAuthGuardService {
    constructor(authToken, router, urlForAuthenticated, urlForAuthentication, publicOnlyRoutes) {
        this.authToken = authToken;
        this.router = router;
        this.urlForAuthenticated = urlForAuthenticated;
        this.urlForAuthentication = urlForAuthentication;
        this.publicOnlyRoutes = publicOnlyRoutes;
        this.returnUrlQueryParam = 'returnUrl';
        this.urlForAuthenticated = this.urlForAuthenticated || '/';
        this.urlForAuthentication = this.urlForAuthentication || '/login';
        this.onAuthTokenChangeSubscription = this.authToken.value$.subscribe(() => {
            this.checkCurrentUrl();
        });
    }
    ngOnDestroy() {
        if (this.onAuthTokenChangeSubscription) {
            this.onAuthTokenChangeSubscription.unsubscribe();
            this.onAuthTokenChangeSubscription = undefined;
        }
    }
    canActivate(route, state) {
        const url = state.url;
        const tokenIsValid = this.authToken.isValid();
        // Check if the user is logged in and trying to get on e.g. /login in that case -> /dashboard
        const isPublicOnlyPage = this.publicOnlyRoutes && this.publicOnlyRoutes.test(url);
        if (tokenIsValid) {
            // logged in user
            if (isPublicOnlyPage) {
                // logged in user tries accessing public only page e.g. /login so Deny and redirect -> /dashboard
                this.navigateForAuthenticated(route, state);
                return false;
            }
            else {
                // logged in user tries accessing page for logged in users so Allow
                return true;
            }
        }
        else {
            // not logged in user
            if (isPublicOnlyPage) {
                // not logged in user tries accessing public only page e.g. /login so Allow
                return true;
            }
            else {
                // not logged in user tries accessing protected page e.g. /dashboard so Deny
                this.navigateForAuthentication(route, state);
                return false;
            }
        }
    }
    canActivateChild(route, state) {
        return this.canActivate(route, state);
    }
    checkCurrentUrl() {
        if (this.router.navigated) {
            this.canActivate(this.router.routerState.root.snapshot, this.router.routerState.snapshot);
        }
    }
    /**
     * Navigate from public only route to route for authenticated users
     */
    navigateForAuthenticated(route, state) {
        const gotoUrl = route.queryParams[this.returnUrlQueryParam] || this.urlForAuthenticated;
        return this.router.navigateByUrl(gotoUrl);
    }
    /**
     * Navigate from route for authenticated users to route to authenticate
     */
    navigateForAuthentication(route, state) {
        const returnUrl = route.queryParams[this.returnUrlQueryParam] || state.url;
        // Store the attempted URL for login form to return back to returnUrl
        return this.router.navigate([this.urlForAuthentication], {
            queryParams: {
                [this.returnUrlQueryParam]: returnUrl
            }
        });
    }
}
ApiAuthGuardService.ɵfac = function ApiAuthGuardService_Factory(t) { return new (t || ApiAuthGuardService)(ɵngcc0.ɵɵinject(AuthTokenService), ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(API_AUTH_GUARD_URL_FOR_AUTHENTICATED, 8), ɵngcc0.ɵɵinject(API_AUTH_GUARD_URL_FOR_AUTHENTICATION, 8), ɵngcc0.ɵɵinject(API_AUTH_GUARD_PUBLIC_ONLY_ROUTES, 8)); };
/** @nocollapse */ ApiAuthGuardService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApiAuthGuardService_Factory() { return new ApiAuthGuardService(i0.ɵɵinject(AuthTokenService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(API_AUTH_GUARD_URL_FOR_AUTHENTICATED, 8), i0.ɵɵinject(API_AUTH_GUARD_URL_FOR_AUTHENTICATION, 8), i0.ɵɵinject(API_AUTH_GUARD_PUBLIC_ONLY_ROUTES, 8)); }, token: ApiAuthGuardService, providedIn: "root" });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
ApiAuthGuardService.ctorParameters = () => [
    { type: AuthTokenService },
    { type: Router },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [API_AUTH_GUARD_URL_FOR_AUTHENTICATED,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [API_AUTH_GUARD_URL_FOR_AUTHENTICATION,] }] },
    { type: RegExp, decorators: [{ type: Optional }, { type: Inject, args: [API_AUTH_GUARD_PUBLIC_ONLY_ROUTES,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApiAuthGuardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: AuthTokenService }, { type: ɵngcc1.Router }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_AUTH_GUARD_URL_FOR_AUTHENTICATED]
            }] }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_AUTH_GUARD_URL_FOR_AUTHENTICATION]
            }] }, { type: RegExp, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_AUTH_GUARD_PUBLIC_ONLY_ROUTES]
            }] }]; }, null); })();

/**
 * `HttpHandler` which applies an `HttpInterceptor` to an `HttpRequest`.
 *
 * @see https://github.com/angular/angular/blob/6.0.x/packages/common/http/src/interceptor.ts#L52
 */
class HttpInterceptorHandler {
    constructor(next, interceptor) {
        this.next = next;
        this.interceptor = interceptor;
    }
    handle(req) {
        return this.interceptor.intercept(req, this.next);
    }
}
/**
 * A multi-provider token which represents the array of `HttpInterceptor`s that
 * are registered for ApiHttp
 *
 *
 */
const API_HTTP_INTERCEPTORS = new InjectionToken('API_HTTP_INTERCEPTORS');
const API_HTTP_INTERCEPTORS_INJECTION_TOKEN = new InjectionToken('API_HTTP_INTERCEPTORS_INJECTION_TOKEN', { providedIn: 'root', factory: () => API_HTTP_INTERCEPTORS });

const API_HTTP_BASE_URL = new InjectionToken('API_HTTP_BASE_URL', {
    providedIn: 'root',
    factory: () => '/api'
});

class ApiBaseUrlInterceptor {
    constructor(apiHttpBaseUrl) {
        this.apiHttpBaseUrl = apiHttpBaseUrl;
        // trim the last / e.g. `//localhost:3000/api/` -> `//localhost:3000/api`
        this.apiHttpBaseUrl = apiHttpBaseUrl.replace(/\/+$/, '');
    }
    intercept(req, next) {
        req = req.clone({
            url: `${this.apiHttpBaseUrl}${req.url}`
        });
        return next.handle(req);
    }
}
ApiBaseUrlInterceptor.ɵfac = function ApiBaseUrlInterceptor_Factory(t) { return new (t || ApiBaseUrlInterceptor)(ɵngcc0.ɵɵinject(API_HTTP_BASE_URL)); };
/** @nocollapse */ ApiBaseUrlInterceptor.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApiBaseUrlInterceptor_Factory() { return new ApiBaseUrlInterceptor(i0.ɵɵinject(API_HTTP_BASE_URL)); }, token: ApiBaseUrlInterceptor, providedIn: "root" });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
ApiBaseUrlInterceptor.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [API_HTTP_BASE_URL,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApiBaseUrlInterceptor, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [API_HTTP_BASE_URL]
            }] }]; }, null); })();

const API_HTTP_DEFAULT_HEADERS = new InjectionToken('API_HTTP_DEFAULT_HEADERS', {
    providedIn: 'root',
    factory: () => ({
        accept: 'application/json, */*'
    })
});

class ApiDefaultHeadersInterceptor {
    constructor(apiHttpDefaultHeaders) {
        if (!(apiHttpDefaultHeaders instanceof HttpHeaders)) {
            apiHttpDefaultHeaders = new HttpHeaders(apiHttpDefaultHeaders);
        }
        this.defaultHeaders = apiHttpDefaultHeaders;
    }
    intercept(req, next) {
        req = this.reqWithDefaultHeaders(req);
        return next.handle(req);
    }
    reqWithDefaultHeaders(req) {
        const headers = Array.from(this.defaultHeaders.keys()).reduce((prevHeaders, headerName) => {
            // override only if not defined already
            if (!prevHeaders.has(headerName)) {
                prevHeaders = prevHeaders.set(headerName, this.defaultHeaders.get(headerName));
            }
            return prevHeaders;
        }, req.headers);
        return req.clone({
            headers
        });
    }
}
ApiDefaultHeadersInterceptor.ɵfac = function ApiDefaultHeadersInterceptor_Factory(t) { return new (t || ApiDefaultHeadersInterceptor)(ɵngcc0.ɵɵinject(API_HTTP_DEFAULT_HEADERS, 8)); };
/** @nocollapse */ ApiDefaultHeadersInterceptor.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApiDefaultHeadersInterceptor_Factory() { return new ApiDefaultHeadersInterceptor(i0.ɵɵinject(API_HTTP_DEFAULT_HEADERS, 8)); }, token: ApiDefaultHeadersInterceptor, providedIn: "root" });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
ApiDefaultHeadersInterceptor.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [API_HTTP_DEFAULT_HEADERS,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApiDefaultHeadersInterceptor, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [API_HTTP_DEFAULT_HEADERS]
            }] }]; }, null); })();

const API_HTTP_AUTHORIZATION_HEADER_NAME = new InjectionToken('API_HTTP_AUTHORIZATION_HEADER_NAME', {
    factory: () => 'Authorization'
});

const API_HTTP_AUTHORIZATION_HEADER_TOKEN_TYPE_PREFIX = new InjectionToken('API_HTTP_AUTHORIZATION_HEADER_TOKEN_TYPE_PREFIX', {
    factory: () => 'Bearer '
});

class ApiAuthorizationHeaderInterceptor {
    constructor(apiHttpAuthorizationHeaderName, apiHttpAuthorizationHeaderTokenTypePrefix, authTokenService) {
        this.apiHttpAuthorizationHeaderName = apiHttpAuthorizationHeaderName;
        this.apiHttpAuthorizationHeaderTokenTypePrefix = apiHttpAuthorizationHeaderTokenTypePrefix;
        this.authTokenService = authTokenService;
    }
    intercept(req, next) {
        req = this.reqWithAuthorizationHeader(req);
        return next.handle(req);
    }
    /**
     * @experimental the headersWithNoAuthorization support is experimental
     * it might be considered in future this capability to be extracted
     * in an abstract class `ApiNoAuthorizationHeaderInterceptor`
     * then we can have `ApiAuthorizationHeaderInterceptor` implement the interface
     * and provide it using forwardRef or similar.
     * Yet this seems too complex for this stage.
     */
    headersWithNoAuthorization(headers) {
        headers = headers instanceof HttpHeaders ? headers : new HttpHeaders(headers);
        return headers.set(this.apiHttpAuthorizationHeaderName, '');
    }
    reqWithAuthorizationHeader(req) {
        if (!req.headers.has(this.apiHttpAuthorizationHeaderName)) {
            // if header is set use the default token
            if (!this.authTokenService.isValid()) {
                throw new Error(`No valid AuthToken present when requesting: '${req.method} ${req.url}'`);
            }
            req = req.clone({
                headers: req.headers.set(this.apiHttpAuthorizationHeaderName, `${this.apiHttpAuthorizationHeaderTokenTypePrefix}${this.authTokenService.value}`)
            });
        }
        else if (!req.headers.get(this.apiHttpAuthorizationHeaderName)) {
            // if header is set and is given token, ensure the header is deleted
            req = req.clone({
                headers: req.headers.delete(this.apiHttpAuthorizationHeaderName)
            });
        }
        // otherwise leave whatever is set so far
        return req;
    }
}
ApiAuthorizationHeaderInterceptor.ɵfac = function ApiAuthorizationHeaderInterceptor_Factory(t) { return new (t || ApiAuthorizationHeaderInterceptor)(ɵngcc0.ɵɵinject(API_HTTP_AUTHORIZATION_HEADER_NAME), ɵngcc0.ɵɵinject(API_HTTP_AUTHORIZATION_HEADER_TOKEN_TYPE_PREFIX), ɵngcc0.ɵɵinject(AuthTokenService)); };
/** @nocollapse */ ApiAuthorizationHeaderInterceptor.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApiAuthorizationHeaderInterceptor_Factory() { return new ApiAuthorizationHeaderInterceptor(i0.ɵɵinject(API_HTTP_AUTHORIZATION_HEADER_NAME), i0.ɵɵinject(API_HTTP_AUTHORIZATION_HEADER_TOKEN_TYPE_PREFIX), i0.ɵɵinject(AuthTokenService)); }, token: ApiAuthorizationHeaderInterceptor, providedIn: "root" });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
ApiAuthorizationHeaderInterceptor.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [API_HTTP_AUTHORIZATION_HEADER_NAME,] }] },
    { type: String, decorators: [{ type: Inject, args: [API_HTTP_AUTHORIZATION_HEADER_TOKEN_TYPE_PREFIX,] }] },
    { type: AuthTokenService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApiAuthorizationHeaderInterceptor, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [API_HTTP_AUTHORIZATION_HEADER_NAME]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [API_HTTP_AUTHORIZATION_HEADER_TOKEN_TYPE_PREFIX]
            }] }, { type: AuthTokenService }]; }, null); })();

class ApiHttpHandlerService {
    constructor(backend, injector, apiHttpInterceptorsInjectionToken) {
        this.backend = backend;
        this.injector = injector;
        this.apiHttpInterceptorsInjectionToken = apiHttpInterceptorsInjectionToken;
        this.chain = null;
        this.apiAuthorizationInterceptor = null;
    }
    handle(req) {
        if (this.chain === null) {
            const interceptors = this.injector.get(this.apiHttpInterceptorsInjectionToken, []);
            this.chain = interceptors.reduceRight((next, interceptor) => new HttpInterceptorHandler(next, interceptor), this.backend);
        }
        return this.chain.handle(req);
    }
    /**
     * @experimental the headersWithNoAuthorization support is experimental
     * see {@link ApiAuthorizationHeaderInterceptor#headersWithNoAuthorization} for details
     */
    headersWithNoAuthorization(headers) {
        if (this.apiAuthorizationInterceptor === null) {
            this.apiAuthorizationInterceptor = this.injector
                .get(this.apiHttpInterceptorsInjectionToken, [])
                .find((interceptor) => interceptor instanceof ApiAuthorizationHeaderInterceptor);
        }
        return this.apiAuthorizationInterceptor.headersWithNoAuthorization(headers);
    }
}
ApiHttpHandlerService.ɵfac = function ApiHttpHandlerService_Factory(t) { return new (t || ApiHttpHandlerService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpHandler), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(API_HTTP_INTERCEPTORS_INJECTION_TOKEN)); };
/** @nocollapse */ ApiHttpHandlerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApiHttpHandlerService_Factory() { return new ApiHttpHandlerService(i0.ɵɵinject(i1.HttpHandler), i0.ɵɵinject(i0.INJECTOR), i0.ɵɵinject(API_HTTP_INTERCEPTORS_INJECTION_TOKEN)); }, token: ApiHttpHandlerService, providedIn: "root" });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
ApiHttpHandlerService.ctorParameters = () => [
    { type: HttpHandler },
    { type: Injector },
    { type: InjectionToken, decorators: [{ type: Inject, args: [API_HTTP_INTERCEPTORS_INJECTION_TOKEN,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApiHttpHandlerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpHandler }, { type: ɵngcc0.Injector }, { type: ɵngcc0.InjectionToken, decorators: [{
                type: Inject,
                args: [API_HTTP_INTERCEPTORS_INJECTION_TOKEN]
            }] }]; }, null); })();

class ApiHttpService extends HttpClient {
    constructor(apiHttpHandler) {
        super(apiHttpHandler);
        this.apiHttpHandler = apiHttpHandler;
    }
    /**
     * @experimental the headersWithNoAuthorization support is experimental
     * see {@link ApiAuthorizationHeaderInterceptor#headersWithNoAuthorization} for details
     */
    headersWithNoAuthorization(headers) {
        return this.apiHttpHandler.headersWithNoAuthorization(headers);
    }
}
ApiHttpService.ɵfac = function ApiHttpService_Factory(t) { return new (t || ApiHttpService)(ɵngcc0.ɵɵinject(ApiHttpHandlerService)); };
/** @nocollapse */ ApiHttpService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApiHttpService_Factory() { return new ApiHttpService(i0.ɵɵinject(ApiHttpHandlerService)); }, token: ApiHttpService, providedIn: "root" });
/**
 * @type {function(): !Array<(null|{
 *   type: ?,
 *   decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>),
 * })>}
 * @nocollapse
 */
ApiHttpService.ctorParameters = () => [
    { type: ApiHttpHandlerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApiHttpService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ApiHttpHandlerService }]; }, null); })();

/*
 * Public API Surface of ngx-api-utils/auth-token
 */

/**
 * Filters object properties stripping any `undefined` value and naively casting any value to string
 * This is quite useful for preparing params for GET requests
 */
function prepareParams(params) {
    return Object.keys(params).reduce((preparedParams, k) => {
        const v = params[k];
        if (v !== undefined) {
            preparedParams[k] = String(v);
        }
        return preparedParams;
    }, {});
}

class NgxApiUtilsModule {
}
NgxApiUtilsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxApiUtilsModule });
NgxApiUtilsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxApiUtilsModule_Factory(t) { return new (t || NgxApiUtilsModule)(); }, providers: [
        {
            provide: API_HTTP_INTERCEPTORS,
            useExisting: ApiBaseUrlInterceptor,
            multi: true
        },
        {
            provide: API_HTTP_INTERCEPTORS,
            useExisting: ApiDefaultHeadersInterceptor,
            multi: true
        },
        {
            provide: API_HTTP_INTERCEPTORS,
            useExisting: ApiAuthorizationHeaderInterceptor,
            multi: true
        }
    ], imports: [[HttpClientModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxApiUtilsModule, { imports: function () { return [HttpClientModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxApiUtilsModule, [{
        type: NgModule,
        args: [{
                imports: [HttpClientModule],
                declarations: [],
                exports: [],
                providers: [
                    {
                        provide: API_HTTP_INTERCEPTORS,
                        useExisting: ApiBaseUrlInterceptor,
                        multi: true
                    },
                    {
                        provide: API_HTTP_INTERCEPTORS,
                        useExisting: ApiDefaultHeadersInterceptor,
                        multi: true
                    },
                    {
                        provide: API_HTTP_INTERCEPTORS,
                        useExisting: ApiAuthorizationHeaderInterceptor,
                        multi: true
                    }
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of ngx-api-utils
 */

/**
 * Generated bundle index. Do not edit.
 */

export { API_AUTH_GUARD_PUBLIC_ONLY_ROUTES, API_AUTH_GUARD_URL_FOR_AUTHENTICATED, API_AUTH_GUARD_URL_FOR_AUTHENTICATION, API_HTTP_AUTHORIZATION_HEADER_NAME, API_HTTP_AUTHORIZATION_HEADER_TOKEN_TYPE_PREFIX, API_HTTP_BASE_URL, API_HTTP_DEFAULT_HEADERS, API_HTTP_INTERCEPTORS, API_HTTP_INTERCEPTORS_INJECTION_TOKEN, AUTH_TOKEN_AUTO_REMOVE, AUTH_TOKEN_NAME, ApiAuthGuardService, ApiAuthorizationHeaderInterceptor, ApiBaseUrlInterceptor, ApiDefaultHeadersInterceptor, ApiHttpHandlerService, ApiHttpService, AuthTokenService, NgxApiUtilsModule, TokenDecoder, TokenPayload, TokenStorage, prepareParams, localStorageFactory as ɵa };

//# sourceMappingURL=ngx-api-utils.js.map